import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import Home from './components/Home';
import Header from './components/Header';
import Events from "./components/Events";
import Contact from './components/Contact';
import Footer from './components/Footer';
import Journey from "./components/Journey";
import Policies from "./components/Policies";
import Rjc from "./components/Rjc";
import Provenance from "./components/Provenance";
import What from "./components/What";
import Contactus from "./components/Contactus";
import Custom from "./components/Custom";
import Diamond from './components/Diamond';
import About from "./components/About";
import Expert from "./components/Expert"; 
import History from "./components/History";
import Compliances from "./components/History";
import usePageTracking from './components/usePageTracking'; // 👈 import tracking
import GemGeneve from "./components/gemgeneve";
import { useLocation } from "react-router-dom";

function AppWrapper() {
  usePageTracking(); // ✅ Moved here - inside Router context
  const location = useLocation(); // 👈 get the current path

  return (
    <div>
    {/* ✅ Hide Navbar on /gemgeneve route */}
    {location.pathname !== "/gemgeneve" && <Navbar />}

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/contactus" element={<Contactus />} />
      <Route path="/diamonds" element={<Diamond />} />
      <Route path="/history" element={<History />} />
      <Route path="/gemgeneve" element={<GemGeneve />} />
    </Routes>

    <Footer />
  </div>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;



